import { Button, Css, DnDGrid, useModal } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { BaseGroupCard } from "src/routes/bids/plan-based-bid-package/components/BaseGroupCard";
import { BasePlanGroupDimensionsModal } from "src/routes/bids/plan-based-bid-package/components/BasePlanGroupDimensionsModal";
import {
  groupKey,
  isBaseGroup,
  PlanBasedBidPackageFormState,
  reorderGroups,
} from "src/routes/bids/plan-based-bid-package/utils";

type BasePlanSectionProps = {
  formState: ObjectState<PlanBasedBidPackageFormState>;
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
  productOfferings: ConfigureBidGroupsStepQuery["bidPackage"]["productOfferings"];
};

export function BasePlanSection(props: BasePlanSectionProps) {
  const { formState, dimensionResults, productOfferings } = props;
  const { openModal } = useModal();
  const baseGroups = formState.bidPlanGroups.rows
    .filter((g) => isBaseGroup(g.value))
    .sortBy((g) => g.order.value ?? Infinity);

  return (
    <div css={Css.df.fdc.gap2.mb6.$}>
      <div css={Css.df.aic.jcsb.$}>
        <div css={Css.lg.$}>Base Bid Cost Dimensions</div>
        <Button
          icon="plus"
          label="Add Group"
          variant="secondary"
          onClick={() =>
            openModal({
              content: <BasePlanGroupDimensionsModal formState={formState} dimensionResults={dimensionResults} />,
            })
          }
        />
      </div>
      <div>
        Add cost dimensions that affect the base bid. If none are added, the base bid will have one cost line per
        product offering.
      </div>
      {baseGroups.isEmpty ? (
        <div css={Css.bgGray100.br8.py3.tac.gray700.$}>No cost dimensions added.</div>
      ) : (
        <DnDGrid
          onReorder={(newIds) =>
            formState.bidPlanGroups.set(reorderGroups(formState.bidPlanGroups.value ?? [], newIds))
          }
          gridStyles={Css.dg.gtc("minmax(0, 1fr)").gap2.$}
        >
          {baseGroups.map((group) => (
            <BaseGroupCard
              key={groupKey(group.value)}
              formState={formState}
              group={group}
              dimensionResults={dimensionResults}
              productOfferings={productOfferings}
            />
          ))}
        </DnDGrid>
      )}
    </div>
  );
}
